import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../../contexts/SiteSettingsContext';
import { Loader2 } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import Maintenance from '../../pages/Maintenance';
import ComingSoon from '../../pages/ComingSoon';
import FloatingChatSystem from '../FloatingChatSystem';

const Layout = ({ children }) => {
  const location = useLocation();
  const { loading: settingsLoading } = useSiteSettings();
  const [SpecialDayBanner, setSpecialDayBanner] = useState(null);
  
  // Check for mode parameter in URL
  const urlParams = new URLSearchParams(location.search);
  const mode = urlParams.get('mode');

  // Get the SpecialDayBanner component from window object
  useEffect(() => {
    const checkForBanner = () => {
      if (typeof window !== 'undefined' && window.SpecialDayBanner) {
        setSpecialDayBanner(() => window.SpecialDayBanner);
      }
    };

    checkForBanner();
    
    // Check periodically in case the component is loaded later
    const interval = setInterval(checkForBanner, 100);
    
    return () => clearInterval(interval);
  }, []);
  
  // Settings loading is handled by the main AdminControlledLoadingScreen
  // No need for additional loading screen here
  
  // If mode parameter is present, show the appropriate content with main header/footer
  if (mode === 'maintenance') {
    return (
      <>
        <div className="App">
          {/* Special Day Banner - rendered before header */}
          {SpecialDayBanner && <SpecialDayBanner />}
          <Header />
          <main>
            <Maintenance />
          </main>
          <Footer />
        </div>
        {/* Floating Chat System - placed outside App container for independent floating */}
        <FloatingChatSystem />
      </>
    );
  }
  
  if (mode === 'coming-soon') {
    return (
      <>
        <div className="App">
          {/* Special Day Banner - rendered before header */}
          {SpecialDayBanner && <SpecialDayBanner />}
          <Header />
          <main>
            <ComingSoon />
          </main>
          <Footer />
        </div>
        {/* Floating Chat System - placed outside App container for independent floating */}
        <FloatingChatSystem />
      </>
    );
  }
  
  // Default layout with header, main content, and footer
  return (
    <>
      <div className="App">
        {/* Special Day Banner - rendered before header */}
        {SpecialDayBanner && <SpecialDayBanner />}
        <Header />
        <main>
          {children}
        </main>
        <Footer />
      </div>
      {/* Floating Chat System - placed outside App container for independent floating */}
      <FloatingChatSystem />
    </>
  );
};

export default Layout;
